import { supabase } from './supabase';
import { Tables } from '../types/database.types';

export type FraudReport = Tables<'fraud_reports'>;

class FraudReportsService {
  /**
   * Get public fraud reports for a specific poll option
   */
  async getByPollOption(pollOptionId: string): Promise<FraudReport[]> {
    const { data, error } = await supabase
      .from('fraud_reports')
      .select('*')
      .eq('poll_option_id', pollOptionId)
      .eq('is_public', true)
      .order('detected_at', { ascending: false });

    if (error) throw error;
    return data || [];
  }

  /**
   * Get all public fraud reports for a poll
   */
  async getByPoll(pollId: string): Promise<FraudReport[]> {
    const { data, error } = await supabase
      .from('fraud_reports')
      .select(`
        *,
        poll_options!inner(
          poll_id
        )
      `)
      .eq('poll_options.poll_id', pollId)
      .eq('is_public', true)
      .order('detected_at', { ascending: false });

    if (error) throw error;
    return data || [];
  }
}

export const fraudReportsService = new FraudReportsService();
